<div class="modal-overlay" *ngIf="isOpen" (click)="onClose()">
  <div
    class="modal-container"
    [class.modal-container-mms]="isRichCouponForm"
    [class.modal-container-email]="formData.emailChannelEnabled"
    (click)="$event.stopPropagation()"
  >
    <div class="modal-header">
      <h2 class="modal-title">{{ isEditMode ? 'Edit SMS/Email' : 'Configure SMS/Email' }}</h2>
      <button type="button" class="close-button" (click)="onClose()" aria-label="Close">
        <svg
          width="14"
          height="14"
          viewBox="0 0 14 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M13 1L1 13M1 1L13 13"
            stroke="#555963"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </button>
    </div>

    <div class="modal-content">
      <div class="form-section">
        <div class="form-group-block channel-toggle-section" *ngIf="showChannelToggles">
          <label class="form-label">Channel</label>
          <div class="channel-toggle-group" role="group" aria-label="Delivery channel">
            <button
              type="button"
              class="channel-toggle-btn"
              [class.active]="formData.smsChannelEnabled"
              (click)="toggleChannel('sms')"
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12.6832 2.49841H7.31491C4.19398 2.49841 1.66406 5.18466 1.66406 8.49844C1.66406 11.8121 4.19398 14.4985 7.31491 14.4985H8.44508C9.22532 14.4985 9.85779 15.17 9.85779 15.9985V17.4984C15.7191 13.5388 18.2973 12.5404 18.3336 8.58387C18.3339 8.55548 18.3341 8.52702 18.3341 8.49844C18.3341 5.1847 15.8041 2.49841 12.6832 2.49841Z"
                  stroke="white"
                  stroke-width="1.5"
                  stroke-miterlimit="10"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M8.5 8.53613H11.5"
                  stroke="white"
                  stroke-width="1.5"
                  stroke-miterlimit="10"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>

              SMS
            </button>
            <button
              type="button"
              class="channel-toggle-btn"
              [class.active]="formData.emailChannelEnabled"
              (click)="toggleChannel('email')"
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M2.1875 6.17126L6.78459 8.88924C9.46471 10.4738 10.5359 10.4738 13.2161 8.88924L17.8132 6.17126"
                  stroke="#15172E"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M2 9.99988C2 6.70005 2 5.05013 3.17157 4.025C4.34315 2.99988 6.22876 2.99988 10 2.99988C13.7712 2.99988 15.6569 2.99988 16.8284 4.025C18 5.05013 18 6.70005 18 9.99988C18 13.2997 18 14.9496 16.8284 15.9748C15.6569 16.9999 13.7712 16.9999 10 16.9999C6.22876 16.9999 4.34315 16.9999 3.17157 15.9748C2 14.9496 2 13.2997 2 9.99988Z"
                  stroke="#15172E"
                  stroke-width="1.5"
                />
              </svg>

              Email
            </button>
          </div>
          <p class="channel-selected-label">Selected: {{ selectedChannelLabel }}</p>
        </div>

        <ng-container *ngIf="smsPlatformEnabled && formData.smsChannelEnabled">
          <div class="form-group-block">
            <label class="form-label">Message type</label>
            <div class="message-type-grid" role="group" aria-label="Message type">
              <button
                *ngFor="let type of messageTypes"
                type="button"
                class="message-type-card"
                [class.selected]="formData.messageType === type.id"
                (click)="selectMessageType(type.id)"
              >
                <span class="message-type-title">{{ type.label }}</span>
                <span class="message-type-sub">{{ type.sublabel }}</span>
              </button>
            </div>
          </div>

          <div class="form-group-block toggle-row" *ngIf="isRichCouponForm">
            <span class="toggle-row-label">Split into two bubbles (image + text)</span>
            <label class="toggle-switch" [class.on]="formData.splitTwoBubbles">
              <input
                type="checkbox"
                class="toggle-switch-input"
                [(ngModel)]="formData.splitTwoBubbles"
                (ngModelChange)="onSplitToggleChange($event)"
              />
              <span class="toggle-switch-track" aria-hidden="true">
                <span class="toggle-switch-knob"></span>
              </span>
            </label>
          </div>

          <!-- Bubble 1: always visible for rich coupon forms; title hidden when split is off -->
          <ng-container *ngIf="isRichCouponForm">
            <div class="bubble-section">
              <h3 class="bubble-section-title" *ngIf="isSplitEnabled">Message bubble 1</h3>
              <p class="bubble-section-subtitle">Coupon image ({{ richMessageTypeLabel }})</p>

              <div class="form-group-block">
                <label class="form-label-image-text">Image<span class="required">*</span></label>
                <div
                  class="file-upload-container"
                  [class.error]="
                    couponValidationError || (couponTouched && !formData.couponImageUrl)
                  "
                >
                  <div class="file-upload-area" *ngIf="!couponFile && !formData.couponImageUrl">
                    <input
                      type="file"
                      id="rich-coupon-upload"
                      accept=".pdf,.png,.jpg,.jpeg,image/png,image/jpeg,application/pdf"
                      class="file-input"
                      (change)="onCouponUpload($event)"
                    />
                    <label class="file-upload-label" for="rich-coupon-upload">
                      <div class="upload-icon">
                        <svg
                          width="16"
                          height="16"
                          viewBox="0 0 16 16"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          aria-hidden="true"
                        >
                          <path
                            d="M8 1V11M8 11L5 8M8 11L11 8M3 13H13"
                            stroke="#64748B"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      </div>
                      <span class="upload-text"
                        >Drag &amp; drop your files here or <strong>browse</strong> to upload</span
                      >
                      <span class="upload-info">.pdf, .png, .jpg, .jpeg Max file size - 5MB</span>
                    </label>
                  </div>

                  <div class="file-uploaded" *ngIf="couponFile || formData.couponImageUrl">
                    <div class="uploaded-file">
                      <div class="success-icon" *ngIf="!isUploadingCoupon">
                        <svg
                          width="16"
                          height="16"
                          viewBox="0 0 16 16"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          aria-hidden="true"
                        >
                          <circle cx="8" cy="8" r="6" fill="#079271" />
                          <path
                            d="M5.5 8L7 9.5L10.5 6"
                            stroke="white"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      </div>
                      <div class="loading-spinner-icon" *ngIf="isUploadingCoupon">
                        <div class="spinner"></div>
                      </div>
                      <span class="file-name">{{ couponFile?.name || couponFileName }}</span>
                      <button
                        type="button"
                        class="remove-file"
                        (click)="removeCoupon()"
                        [disabled]="isUploadingCoupon"
                        aria-label="Remove coupon image"
                      >
                        <svg
                          width="12"
                          height="12"
                          viewBox="0 0 12 12"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          aria-hidden="true"
                        >
                          <path
                            d="M9 3L3 9M3 3L9 9"
                            stroke="#A7ABB3"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      </button>
                    </div>
                  </div>
                </div>
                <div class="error-message" *ngIf="couponValidationError">
                  {{ couponValidationError }}
                </div>
                <div
                  class="error-message"
                  *ngIf="couponTouched && !formData.couponImageUrl && !couponValidationError"
                >
                  Image is required
                </div>
              </div>

              <div class="form-group-block">
                <label class="form-label-mms-text" for="rich-alt-text">Alternative text</label>
                <input
                  id="rich-alt-text"
                  class="form-input"
                  [(ngModel)]="formData.imageAltText"
                  (ngModelChange)="onFormFieldChange()"
                />
              </div>

              <div class="form-group-block">
                <label class="form-label-mms-text" for="rich-caption">Caption</label>
                <input
                  id="rich-caption"
                  class="form-input"
                  [(ngModel)]="formData.imageCaption"
                  (ngModelChange)="onFormFieldChange()"
                />
              </div>
            </div>

            <div class="mms-fallback-panel">
              <h3 class="form-label">{{ richMessageTypeLabel }} fallback</h3>
              <div class="form-group-block">
                <label class="form-label-box-text" for="rich-fallback-behavior">Behavior</label>
                <div class="form-select-wrap">
                  <select
                    id="rich-fallback-behavior"
                    class="form-input-mms-box form-select"
                    [(ngModel)]="formData.fallbackBehavior"
                    (ngModelChange)="onFormFieldChange()"
                  >
                    <option *ngFor="let option of fallbackBehaviors" [value]="option.value">
                      {{ option.label }}
                    </option>
                  </select>
                  <svg
                    class="form-select-chevron"
                    width="14"
                    height="14"
                    viewBox="0 0 14 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    aria-hidden="true"
                  >
                    <path
                      d="M1 3.6L7 10.4L13 3.6"
                      stroke="#15172E"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
              </div>
              <div class="form-group-block">
                <label class="form-label-box-text" for="rich-fallback-text"
                  >Fallback text<span class="required">*</span></label
                >
                <input
                  id="rich-fallback-text"
                  class="form-input-mms-box"
                  [(ngModel)]="formData.fallbackText"
                  (ngModelChange)="onFormFieldChange()"
                />
              </div>
            </div>
          </ng-container>

          <!-- Bubble 2: only shown when split toggle is ON -->
          <ng-container *ngIf="isRichCouponForm && isSplitEnabled">
            <div class="bubble-section">
              <h3 class="bubble-section-title">Message bubble 2</h3>
              <p class="bubble-section-subtitle">Message body</p>
              <textarea
                id="rich-bubble-2-body"
                class="form-input form-textarea"
                rows="5"
                maxlength="160"
                [(ngModel)]="formData.bubble2TextBody"
                (ngModelChange)="onBubble2TextBodyChange()"
              ></textarea>
              <div class="tags-row">
                <span
                  class="tag"
                  (mousedown)="$event.preventDefault()"
                  (click)="insertTag('Customer_Name', 'bubble2TextBody')"
                  >Customer_Name</span
                >
                <span
                  class="tag"
                  (mousedown)="$event.preventDefault()"
                  (click)="insertTag('Customer_Phone', 'bubble2TextBody')"
                  >Customer_Phone</span
                >
              </div>
              <div class="warning-message" *ngIf="bubble2TextBodyValidationError">
                {{ bubble2TextBodyValidationError }}
              </div>
            </div>
          </ng-container>

          <div class="form-group-block" *ngIf="!isRichCouponForm">
            <label class="form-label" for="delivery-message-body">Message body</label>
            <textarea
              id="delivery-message-body"
              class="form-input form-textarea"
              rows="5"
              maxlength="160"
              [(ngModel)]="formData.messageBody"
              (ngModelChange)="onMessageBodyChange()"
            ></textarea>
            <div class="tags-row">
              <span
                class="tag"
                (mousedown)="$event.preventDefault()"
                (click)="insertTag('Customer_Name', 'messageBody')"
                >Customer_Name</span
              >
              <span
                class="tag"
                (mousedown)="$event.preventDefault()"
                (click)="insertTag('Customer_Phone', 'messageBody')"
                >Customer_Phone</span
              >
            </div>
            <div class="warning-message" *ngIf="messageBodyValidationError">
              {{ messageBodyValidationError }}
            </div>
          </div>
        </ng-container>

        <div
          class="email-message-section"
          *ngIf="emailPlatformEnabled && formData.emailChannelEnabled"
        >
          <h3 class="email-section-title">Email message</h3>
          <div class="form-group-block">
            <label class="form-label-email" for="email-subject"
              >Subject line<span class="required">*</span></label
            >
            <input
              id="email-subject"
              class="form-input"
              type="text"
              [(ngModel)]="formData.emailSubject"
              (ngModelChange)="onEmailFieldChange()"
            />
          </div>
          <div class="form-group-block">
            <label class="form-label-email" for="email-preheader">Preheader</label>
            <input
              id="email-preheader"
              class="form-input"
              type="text"
              [(ngModel)]="formData.emailPreheader"
              (ngModelChange)="onEmailFieldChange()"
            />
          </div>
          <div class="form-group-block">
            <label class="form-label-email" for="email-body">Email body</label>
            <textarea
              id="email-body"
              class="form-input form-textarea"
              rows="4"
              [(ngModel)]="formData.emailBody"
              (ngModelChange)="onEmailFieldChange()"
            ></textarea>
            <div class="tags-row">
              <span
                class="tag"
                (mousedown)="$event.preventDefault()"
                (click)="insertTag('Customer_Name', 'emailBody')"
                >Customer_Name</span
              >
              <span
                class="tag"
                (mousedown)="$event.preventDefault()"
                (click)="insertTag('Customer_Email', 'emailBody')"
                >Customer_Email</span
              >
            </div>
          </div>
        </div>
      </div>

      <div class="preview-section">
        <h3 class="preview-title">Preview</h3>
        <div
          class="preview-stack"
          [class.preview-stack-dual]="
            smsPlatformEnabled &&
            emailPlatformEnabled &&
            formData.smsChannelEnabled &&
            formData.emailChannelEnabled
          "
        >
          <div
            class="preview-message-area"
            *ngIf="smsPlatformEnabled && formData.smsChannelEnabled"
            [class.preview-message-area-stacked]="isRichCouponForm && formData.splitTwoBubbles"
          >
            <ng-container *ngIf="isRichCouponForm; else singleBubblePreview">
              <div class="preview-bubble-row">
                <div class="preview-bubble preview-bubble-media">
                  <div
                    class="preview-coupon-frame"
                    *ngIf="couponPreviewUrl; else couponPlaceholder"
                  >
                    <img [src]="couponPreviewUrl" [alt]="getPreviewAltText()" />
                  </div>
                  <ng-template #couponPlaceholder>
                    <div class="preview-coupon-frame preview-coupon-placeholder">Coupon image</div>
                  </ng-template>
                  <p class="preview-coupon-caption" *ngIf="getPreviewCaption()">
                    {{ getPreviewCaption() }}
                  </p>
                </div>
              </div>
              <div class="preview-bubble-row" *ngIf="isSplitEnabled">
                <div class="preview-bubble">
                  <p class="preview-bubble-text">{{ getPreviewMessage() }}</p>
                </div>
              </div>
            </ng-container>
            <ng-template #singleBubblePreview>
              <div class="preview-bubble-row">
                <div class="preview-bubble">
                  <p class="preview-bubble-text">{{ getPreviewMessage() }}</p>
                </div>
              </div>
            </ng-template>
          </div>

          <div *ngIf="emailPlatformEnabled && formData.emailChannelEnabled">
            <div class="vertical-divider"></div>
            <div class="preview-email-card">
              <p class="preview-email-meta">
                From: campaigns&#64;hub.io · To: alex&#64;example.com
              </p>
              <h4 class="preview-email-subject">{{ getEmailPreviewSubject() }}</h4>
              <hr class="preview-email-divider" />
              <p class="preview-email-preheader">{{ getEmailPreviewPreheader() }}</p>
              <p class="preview-email-body">{{ getEmailPreviewBody() }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" [disabled]="!canReset" (click)="onReset()">
        Reset
      </button>
      <button type="button" class="btn btn-primary" [disabled]="!canSave" (click)="onSave()">
        Save
      </button>
    </div>
  </div>
</div>
